import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-4 pb-6 sm:pt-12 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-290">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.15) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-291"></div>

      {/* Attention Badge */}
      <div className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-3 sm:mb-6 flex items-center gap-1.5 sm:gap-2" data-id="element-292">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red animate-pulse-composited" data-id="element-293"></span>
        <span className="hidden sm:inline" data-id="element-294">
          ATTENZIONE: MAESTRE DI SCUOLA PRIMARIA STANCHE DI PASSARE LE SERATE A
          INVENTARE ATTIVITÀ DI ARTE
        </span>
        <span className="sm:hidden" data-id="element-295">
          ATTENZIONE: MAESTRE DI SCUOLA PRIMARIA
        </span>
      </div>

      {/* Main headline */}
      <h1 className="relative font-black text-text-main max-w-5xl sm:text-5xl md:text-6xl sm:leading-[1.1] mb-2 sm:mb-6 tracking-tight text-[26px]" data-id="element-296">
        Trasforma tutte le tue lezioni di{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400" data-id="element-297">
          ARTE
        </span>{' '}
        in esperienze creative pronte in soli 5 minuti.
      </h1>

      {/* Subheadline */}
      <p className="relative text-text-sec text-[13px] sm:text-xl font-medium leading-relaxed mb-3 sm:mb-8 max-w-3xl mx-auto sm:bg-bg-alt sm:border sm:border-white/10 sm:border-l-4 sm:border-l-primary sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left" data-id="element-298">
        Il primo Kit{' '}
        <span className="text-orange-400 font-bold" data-id="element-299">"Apri e Insegna"</span> con
        laboratori artistici, progetti creativi, percorsi annuali e attività
        pronte dalla 1ª alla 5ª classe.{' '}
        <span className="hidden sm:inline text-text-main font-semibold" data-id="element-300">
          Recupera i tuoi weekend e accelera l'apprendimento dei tuoi alunni.
        </span>
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[260px] sm:max-w-[480px] md:max-w-[560px] mx-auto mb-2 sm:mb-8" data-id="element-301">
        <div className="absolute inset-0 rounded-full pointer-events-none" style={{
        background: 'radial-gradient(circle, rgba(234,88,12,0.15) 0%, transparent 70%)'
      }} aria-hidden="true" data-id="element-302"></div>
        <img src="https://cdn.magicpatterns.com/uploads/nngprXcT4QBKHQLML4Syfa/FOTO_ARTE-Photoroom.png" alt="Arte Pronta — Kit Didattico Completo" className="relative w-full h-auto object-contain" width={420} height={420} sizes="(max-width: 640px) 220px, (max-width: 768px) 360px, 420px" fetchPriority="high" decoding="async" data-id="element-303" />
      </div>

      {/* Stars + Urgency */}
      <div className="relative flex flex-col items-center gap-1.5 sm:gap-2 mb-3 sm:mb-6" data-id="element-304">
        <div className="flex items-center gap-2" data-id="element-305">
          <span className="text-secondary text-sm sm:text-lg" data-id="element-306">⭐⭐⭐⭐⭐</span>
          <span className="text-text-sec text-xs sm:text-base font-medium" data-id="element-307">
            4.9/5 (+1.200 Recensioni Verificate)
          </span>
        </div>
        <span className="text-secondary font-bold text-xs sm:text-sm bg-secondary/10 px-3 py-1 rounded-full border border-secondary/20" data-id="element-308">
          🔥 73 insegnanti hanno scelto questo Kit oggi
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" style={{
      boxShadow: '0 0 12px rgba(57,255,20,0.25), 0 6px 18px rgba(0,0,0,0.25)'
    }} className="relative btn-primary-pulse font-black text-base sm:text-2xl px-6 sm:px-12 py-3.5 sm:py-5 rounded-2xl inline-block mb-2 sm:mb-4 w-full sm:w-auto max-w-xl border-2 border-white/30 uppercase tracking-tight transition-transform hover:scale-[1.02] active:scale-[0.99] text-[#FFFFFF] bg-[#22C55E]" data-id="element-309">
        🚀 SÌ! VOGLIO RECUPERARE IL MIO TEMPO
      </a>

      {/* Trust badges */}
      <p className="relative text-text-sec text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-310">
        <span data-id="element-311">⚡ Accesso Immediato</span>
        <span data-id="element-312">•</span>
        <span data-id="element-313">🛡️ Garanzia 7 Giorni</span>
        <span data-id="element-314">•</span>
        <span data-id="element-315">💳 Pagamento Unico</span>
      </p>
    </section>;
}